import validate from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/node_modules/nuxt/dist/pages/runtime/validate.js";
import admin_45global from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/middleware/admin.global.ts";
import prop_45routes_45global from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/middleware/propRoutes.global.ts";
import routers_45history_45global from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/middleware/routers.history.global.ts";
import manifest_45route_45rule from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  admin_45global,
  prop_45routes_45global,
  routers_45history_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "block-error-direct": () => import("/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/middleware/block-error-direct.ts")
}